import { ROUTES } from "@app/config/constants";
import { useAuthStore } from "@lib/auth/authStore";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { Settings } from "lucide-react";
import { SettingsManager } from "@/features/settings";

/**
 * Parameters route — explicit loader.
 *
 * Product decision (PLAN-admin-module Tâche 6.2, audit 17 §1.4): "permission vide =
 * accès authentifié". `/parametres` is reachable by every authenticated user; no
 * permission string is invented (none exists in PermissionCode.php for this route).
 * The isLoggedIn assertion mirrors the parent `_app` loader (routing.md §8,
 * pattern 3) as explicit, documented defense in depth.
 */
export const Route = createFileRoute("/_app/parametres")({
  loader: async ({ location }) => {
    const { isLoggedIn } = useAuthStore.getState();
    if (!isLoggedIn) {
      throw redirect({ to: ROUTES.APP.AUTH_LOGIN, search: { redirect: location.href } });
    }
  },
  staticData: {
    title: "Paramètres",
    section: "Général",
    order: 99,
    showInTab: false,
    showInBreadcrumb: true,
    icon: Settings,
  },
  component: ParametresPage,
});

function ParametresPage() {
  return <SettingsManager />;
}
